import { useCallback, useState } from "react";
import {
  AuthApi,
  type RegistrationEligibilityParams,
  type RegistrationEligibilityResult,
} from "../../infrastructure/api/AuthApi";

export const useRegistrationEligibility = () => {
  const [pendingRequests, setPendingRequests] = useState(0);
  const [error, setError] = useState<string | null>(null);

  const checkRegistrationEligibility = useCallback(
    async (
      params: RegistrationEligibilityParams,
    ): Promise<RegistrationEligibilityResult> => {
      setPendingRequests((count) => count + 1);
      setError(null);

      try {
        const api = new AuthApi();
        return await api.checkRegistrationEligibility(params);
      } catch (err: unknown) {
        const message =
          err instanceof Error
            ? err.message
            : "Unable to validate registration details. Please try again.";
        setError(message);
        throw err;
      } finally {
        setPendingRequests((count) => Math.max(count - 1, 0));
      }
    },
    [],
  );

  return {
    checkRegistrationEligibility,
    loading: pendingRequests > 0,
    error,
  };
};
